import React, { ReactNode } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import url from '@/utils/config';
import Button from '@/components/atoms/Button';
import AlertState from '@/states/alertState';
import applicationErrorDialogState from '@/mobile/states/applicationErrorDialogState';

type Props = {
  message: ReactNode; // ダイアログに表示するメッセージ
};

/**
 * モバイル契約系フローで処理継続できない場合に表示する共通エラーダイアログ。
 * @param param0 ダイアログに表示する文言
 * @returns エラーダイアログ
 */
const ApplicationErrorDialog = ({ message }: Props) => {
  const [applicationErrorDialog, setApplicationErrorDialog] = useRecoilState(
    applicationErrorDialogState
  );
  const alertState = useRecoilValue(AlertState);

  /**
   * エラー状態を閉じたあとは途中画面に残さず、契約トップへ戻して再操作を促す。
   */
  const onClose = () => {
    setApplicationErrorDialog({
      isOpen: false,
    });
    window.location.href = url('/mobile/contract');
  };

  if (applicationErrorDialog.isOpen && !alertState.isOpen) {
    // 二重スクロールを防ぎ、モーダルへの注意を強制するため背景スクロールを止める。
    if (typeof window === 'object') {
      document.body.style.overflow = 'hidden';
    }
    return (
      <>
        <div className='m-modal js-modal is-modal-fade is-modal-show alert-dialog'>
          <div className='m-modal__inner'>
            <div className='m-modal__content align-center'>
              <div className='text-alert'>ご確認ください</div>
              <div className='m-text'>{message}</div>
            </div>
            <div className='m-modal__footer'>
              <div className='m-button align-center'>
                <Button variant='secondary' onClick={onClose}>
                  OK
                </Button>
              </div>
            </div>
          </div>
        </div>
        <span
          role='button'
          tabIndex={0}
          className='fn-overlay is-overlay-show'
          onClick={onClose}
          onKeyDown={onClose}
          aria-label='閉じる'
          data-testid='show'
        />
      </>
    );
  }

  // 閉じたあとに body の scroll lock が残ると他画面操作に影響するため必ず解除する。
  if (typeof window === 'object') {
    document.body.style.overflow = '';
  }

  return <span className='fn-overlay' data-testid='hidden' />;
};

export default ApplicationErrorDialog;
